var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsFillerOn = function SvgPartsFillerOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M12.981 13.938a.572.572 0 0 0 0-1.143h-3.51a.57.57 0 0 0-.572.572v5.266a.572.572 0 0 0 1.143 0v-2.062h2.5a.572.572 0 0 0 0-1.143h-2.5v-1.49zM20.936 27.249h2.749v-2.31h-2.75zm-.878-17.231h4.504v4.504H22.75a.381.381 0 0 0 0 .762h1.813v1.432H22.75a.381.381 0 0 0 0 .762h1.813v1.432H22.75a.381.381 0 0 0 0 .762h1.813v4.505h-4.504zm6.202 17.23h-1.814v-2.31h.497c.21 0 .381-.17.381-.38V9.637c0-.21-.17-.381-.38-.381H22.69V4.37a.381.381 0 0 0-.762 0v4.886h-2.252c-.21 0-.381.17-.381.38v14.922c0 .21.17.38.381.38h.497v2.31H18.36a.381.381 0 0 0 0 .763h7.9a.381.381 0 0 0 0-.762"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M6.121 27.249v-5.696a7.4 7.4 0 0 0 4.885 1.85 7.4 7.4 0 0 0 4.886-1.85v5.696zm9.77-22.498v5.696a7.4 7.4 0 0 0-4.885-1.85 7.4 7.4 0 0 0-4.885 1.85V4.75zm-9.77 6.76a6.64 6.64 0 0 1 4.885-2.152c1.859 0 3.629.786 4.886 2.151v8.98a6.64 6.64 0 0 1-4.886 2.15 6.64 6.64 0 0 1-4.885-2.15zm10.152-7.522H5.74c-.21 0-.38.171-.38.381v23.26c0 .21.17.38.38.38h10.533c.21 0 .38-.17.38-.38V4.37c0-.21-.17-.38-.38-.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M6.095 10.667a4.571 4.571 0 1 1 0-9.143 4.571 4.571 0 0 1 0 9.143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.133 8.7 2.868 6.436l.68-.68L5.133 7.34l3.51-3.51.68.68z"
  }))));
};
export default SvgPartsFillerOn;